var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fax",
    d: "M10,20H5a5,5,0,0,0-5,5V75a5,5,0,0,0,5,5h5a5,5,0,0,0,5-5V25A5,5,0,0,0,10,20Zm65,5V12.07a5,5,0,0,0-1.464-3.536l-7.072-7.07A5,5,0,0,0,62.928,0H25a5,5,0,0,0-5,5V75a5,5,0,0,0,5,5H75a5,5,0,0,0,5-5V30A5,5,0,0,0,75,25ZM45,67.5A2.5,2.5,0,0,1,42.5,70h-5A2.5,2.5,0,0,1,35,67.5v-5A2.5,2.5,0,0,1,37.5,60h5A2.5,2.5,0,0,1,45,62.5Zm0-20A2.5,2.5,0,0,1,42.5,50h-5A2.5,2.5,0,0,1,35,47.5v-5A2.5,2.5,0,0,1,37.5,40h5A2.5,2.5,0,0,1,45,42.5Zm20,20A2.5,2.5,0,0,1,62.5,70h-5A2.5,2.5,0,0,1,55,67.5v-5A2.5,2.5,0,0,1,57.5,60h5A2.5,2.5,0,0,1,65,62.5Zm0-20A2.5,2.5,0,0,1,62.5,50h-5A2.5,2.5,0,0,1,55,47.5v-5A2.5,2.5,0,0,1,57.5,40h5A2.5,2.5,0,0,1,65,42.5ZM67.5,30h-40V7.5H60v5A2.5,2.5,0,0,0,62.5,15h5Z",
    fill: "#f5f5f5",
    opacity: 0.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaxIcon);
export default __webpack_public_path__ + "static/media/FaxIcon.7166071c96087748a4827591e4000b09.svg";
export { ForwardRef as ReactComponent };